import axios from "axios";
import API_MAP, { API_DOMAIN } from "../../constants/api";
import axiosClient, { axiosClientNoRedirect, refreshTokenWrapper } from "../axiosClient";

class ApiManagerUser {
    getUserByToken = () => {
        return axiosClient.get(API_MAP.GET_USER_BY_TOKEN)
    }
    updateUserInfo = (data) => {
        return axiosClient.post(API_MAP.USER.UPDATE_USER, data)
    }

    sendMailVerify = (data) => {
        return axiosClient.post(API_MAP.SEND_MAIL_VERIFY, data)
    }

    getListUser = (data) => {
        let _data = data
        _data.groupId = data.role.filter(r => r)
        delete _data.role
        _data.status = ((data.status)?.length === 2) ? '' : (data.status[0] === 'locked' ? 0 : 1)
        if (data.userType) {
            _data.userType = ((data.userType)?.length === 2 || (data.userType)?.length === 0) ? '' : data.userType[0]
        }

        return axiosClient.post(API_MAP.GET_LIST_USER, _data)
    }
    getUserById = (data) => {
        return axiosClient.get(API_MAP.GET_USER_BY_Id + '/' + data)
    }
    deleteUser = (data) => {
        return axiosClient.post(API_MAP.DELETE_USER, data)
    }
    deleteRole = (data) => {
        return axiosClient.post(API_MAP.DELETE_ROLE, data)
    }
    createUser = (data) => {
        return axiosClient.post(API_MAP.CREAT_USER, data)
    }
    updateAccountRole = (userId, data) => {
        return axiosClient.post(API_DOMAIN + 'account/' + userId + '/roles', data)
    }
    importAccount = (data) => {
        return axiosClient.post(API_MAP.UPLOAD_EXCEL_ACCOUNT, data)
    }
    updateUser = (data) => {
        return axiosClient.post(API_MAP.UPDATE_USER, data)
    }
    updateUserWithAdmin = (data) => {
        return axiosClient.post(API_MAP.UPDATE_USER_WITH_ADMIN, data)
    }
    getAllRole = () => {
        return axiosClient.get(API_MAP.GET_ALL_ROLE)
    }
    getAllUserRole = (userId) => {
        return axiosClient.get(API_DOMAIN + 'account/' + userId + '/roles');
    }
    getAllSystemRole = (data) => {
        const { s, size, page } = data
        return axiosClient.get(API_MAP.GET_SYSTEM_ROLES + `?s=${s}&page=${page}&size=${size}`)
    }
    getListRole = (data) => {
        return axiosClient.post(API_MAP.GET_LIST_ROLE, data)
    }
    createRole = (data) => {
        return axiosClient.post(API_MAP.CREATE_ROLE, data)
    }
    updateRole = (data) => {
        return axiosClient.post(API_MAP.UPDATE_ROLE, data)
    }
    updateListFunction = (id, data) => {
        return axiosClient.post(API_MAP.UPDATE_LIST_FUNCTION + '/' + id, data)
    }
    getListFunctionById = (data) => {
        return axiosClient.post(API_MAP.GET_LIST_FUNCTION_BY_GROUP_ID, data)
    }
    getRoleById = (data) => {
        return axiosClient.get(API_MAP.GET_ROLE_BY_ID + '/' + data)
    }
    getListFunction = (data) => {
        return axiosClient.get(API_MAP.GET_LIST_FUNCTION + '/' + data)
    }

    logout = () => {
        return axiosClient.post(API_MAP.LOGOUT)
    }

    loginGoogle = () => {
        return axiosClient.get(API_MAP.Google)
    }

    register = (data) => {
        return axiosClient.post(API_MAP.REGISTER, data)
    }

    getRoleByToken = () => {
        return axiosClient.get(API_MAP.GET_ROLE_BY_TOKEN)
    }

    getLoginInfo = () => {
        return axiosClient.get(API_MAP.GET_LOGIN_INFO)
    }

    updatePassword = (data) => {
        return axiosClient.post(API_MAP.CHANGE_PASSWORD, data)
    }

    resetPassword = (idAccount, password) => {
        return axiosClient.post(API_MAP.ADMIN_RESET_PASSWORD, { idAccount, password })
    }

    updatePasswordByToken = (data) => {
        return axiosClient.post(API_MAP.CHANGE_PASSWORD_BY_TOKEN, data)
    }
    forgotPassword = (data, email) => {
        return axiosClient.post(API_MAP.FORGOT_PASSWORD + `/${email}`, data)
    }
    createNewPassword = (data) => {
        return axios.post(API_MAP.UPDATE_WITHOUT_PASSWORD, data)
    }
    updateStatusAccount = (data) => {
        return axiosClient.post(API_MAP.UPDATE_ACCOUNT, data)
    }
    getCaptchaRegister = () => {
        return axios.post(API_MAP.GET_CAPTCHA_REGISTER)
    }
    removeAvatar = () => {
        return axiosClient.get(API_MAP.USER.REMOVE_AVATAR)
    }
    checkUserBlock = () => {
        return axiosClient.get(API_MAP.CHECK_USER_BLOCK)
    }
    checkRefreshToken = (refreshToken) => {
        return refreshTokenWrapper(refreshToken)
        // return axiosClient.post(API_MAP.CHECK_REFRESH_TOKEN, {refreshToken})
    }
    verifyGoogleSSO = (data, type, info_sso, pi_share_policies, grant_type = "") => {
        return axiosClientNoRedirect.post(`${API_MAP.VERIFY_GOOGLE}/${type}`, { ...data, info_sso, pi_share_policies, grant_type })
    }
    registerSSO = (data, type, info_sso, pi_share_status, pi_share_policies) => {
        return axiosClient.post(`${API_MAP.REGISTER_SSO}/${type}`, { ...data, info_sso, pi_share_status, pi_share_policies })
    }
    registerSSOLinkAccount = (data, type, info_sso, pi_share_policies) => {
        return axiosClientNoRedirect.post(`${API_MAP.REGISTER_SSO_LINK_ACCOUNT}/${type}`, { ...data, info_sso, pi_share_policies })
    }

    sendOTP = (email, page, pass, username, piShareStatus, piPolicies) => {
        return axiosClient.post(API_MAP.SEND_OTP, { email: email, page: page, username: username, pass: pass, pi_share_status: piShareStatus ? 1 : 0, pi_share_policies: piPolicies })
    }
    verifyOTP = (email, page, code) => {
        return axiosClient.get(API_MAP.VERIFY_OTP + "?email=" + email + "&page=" + page + "&code=" + code)
    }
    checkEmail = (email, nameDatabase, sso = '') => {
        return axiosClient.get(API_MAP.CHECK_EMAIL + "?email=" + email + "&nameDatabase=" + nameDatabase + "&sso=" + sso)
    }
    checkPassword = (pass) => {
        return axiosClient.post(API_MAP.CHECK_PASSWORD, { password: pass })
    }
    linkAccountSSO = (username, password, policies) => {
        return axiosClient.post(API_MAP.LINK_ACCOUNT_SSO, { username, password, pi_share_policies: policies });
    }

    checkRegisterByEmail = (username) => {
        return axiosClient.post(API_MAP.CHECK_REGISTER_BY_EMAIL, { username })
    }

    verifyMail = (email, beforeEmail, otp) => {
        return axiosClient.post(API_MAP.VERIFY_MAIL, { email, beforeEmail, otp });
    }

    getListPackage = ({ package_code, package_name, deployment_system_code, product_package_main, page, size }) => {
        return axiosClient.get(API_MAP.GET_PACKAGES + "?package_code=" + package_code + "&package_name=" + package_name + "&deployment_system_code=" + deployment_system_code + "&product_package_main=" + product_package_main + "&page=" + page + "&size=" + size)
    }

    getPackageDetail = ({ package_id, page, size, license_code, nameOrEmail, deployment_system_code, product_package_active, is_assigned }) => {
        return axiosClient.get(API_MAP.GET_PACKAGE_DETAIL + "?package_id=" + package_id + "&license_code=" + license_code + "&deployment_system_code=" + deployment_system_code + "&nameOrEmail=" + nameOrEmail + "&product_package_active=" + product_package_active + "&is_assigned=" + is_assigned + "&page=" + page + "&size=" + size)
    }

    responseInviteLicense = (licenseCode, statusInvite) => {
        return axiosClient.post(API_MAP.RESPONSE_INVITE_LICENSE, { licenseCode, statusInvite });
    }

    inviteUserAssign = (email, license_code, product_package_id, product_package_name, type) => {
        return axiosClient.post(API_MAP.INVITE_USER_ASSIGN, { email, license_code, product_package_id, product_package_name, type });
    }

    getMyUserLicense = ({ page, size, license_code, package_name, nameOrEmail, status, product_package_main }) => {
        return axiosClient.get(API_MAP.GET_MY_USER_LICENSE + "?page=" + page + "&size=" + size + "&license_code=" + license_code + "&package_name=" + package_name + "&nameOrEmail=" + nameOrEmail + "&status=" + status + "&product_package_main=" + product_package_main);
    }

    getMyInviteLicense = () => {
        return axiosClient.get(API_MAP.GET_MY_INVITE_LICENSE)
    }

    getMyLicense = () => {
        return axiosClient.get(API_MAP.GET_MY_CURRENT_LICENSE)
    }

    unassignLicense = (license_code, accountId) => {
        return axiosClient.post(API_MAP.UNASSIGN_LICENSE, { license_code, account_id: accountId });
    }

    getUserFunctions = () => {
        return axiosClient.get(API_MAP.GET_USER_FUNCTIONS)
    }

    getTotalMeeting = (roomId) => {
        return axiosClient.get(API_MAP.GET_TOTAL_MEETING + "?roomId=" + roomId)
    }

    checkLimitMeeting = (roomId) => {
        return axiosClient.get(API_MAP.CHECK_LIMIT_MEETING + "?roomId=" + roomId)
    }

    updateStatusSharingInfo = (data) => {
        return axiosClient.post(API_MAP.SHARING_INFO.UPDATE_STATUS, data)
    }

    enable2FA = () => {
        return axiosClient.post(API_MAP.AUTH.ENABLE_2FA)
    }

    verifyEnable2FA = (data) => {
        return axiosClient.post(API_MAP.AUTH.VERIFY_ENABLE_2FA, data)
    }

    disable2FA = () => {
        return axiosClient.post(API_MAP.AUTH.DISABLE_2FA)
    }

    reject2FA = () => {
        return axiosClient.post(API_MAP.AUTH.REJECT_2FA)
    }

    current2FA = () => {
        return axiosClient.get(API_MAP.AUTH.CURRENT_2FA)
    }

    requiredRole2FA = () => {
        return axiosClient.get(API_MAP.AUTH.REQUIRED_ROLE_2FA)
    }

    verifyLogin2FA = (data, temp_token) => {
        return axios.post(API_MAP.AUTH.VERIFY_LOGIN_2FA, data, {
            headers: {
                'content-type': 'application/json',
                token: temp_token
            }
        })
    }
}

const apiManagerUser = new ApiManagerUser();

export default apiManagerUser;